import { Chart } from "react-google-charts";
import { ChartColorsDto } from "../../models/Recurrencia.model";
import useMediaQuery from '@mui/material/useMediaQuery';

interface PieChartDto {
    data: [string, number][];
    colors: ChartColorsDto[];
}

export function PieChart({ data, colors }: PieChartDto) {
    const chartData = [["Título", "Cantidad"], ...data];
    const matches = useMediaQuery('(min-width:992px)');

    const options = {
        legend: {
            position: "left",
            alignment: "center",
            textStyle: { fontSize: 20 }
        },
        pieSliceText: 'value-and-percentage',
        chartArea: {
            top: 50,
            height: matches ? 500 : 300,
        },
        slices: colors.length ? colors : [{ color: "red" }, { color: "blue" }],
        // slices: [{ color: "red" }, { color: "blue" }],
        tooltip: {
            textStyle: {
                fontSize: 20
            }
        },

    };

    return (
        <Chart
            chartType="PieChart"
            data={chartData}
            options={options}
            width={"100%"}
            height={600}
        />
    );
}

